export default "__VITE_ASSET__CHi5tcF1__"